import { useEffect, useRef } from 'react'
import { Modal } from 'antd'
import './video-preview-modal.css'

interface VideoPreviewModalProps {
  open: boolean
  src: string | undefined
  title: string | undefined
  onClose: () => void
}

// 与资产库共用的播放器；关闭时立即暂停，弹窗退出动画结束后卸载视频。
export function VideoPreviewModal({
  open,
  src,
  title,
  onClose,
}: VideoPreviewModalProps) {
  const videoRef = useRef<HTMLVideoElement>(null)
  useEffect(() => {
    if (!open) videoRef.current?.pause()
  }, [open])
  return (
    <Modal
      centered
      className="asset-video-preview-modal"
      destroyOnHidden
      footer={null}
      open={open}
      title={title ?? '预览素材'}
      width={960}
      onCancel={onClose}
    >
      {open && src && (
        <video
          ref={videoRef}
          key={src}
          controls
          autoPlay
          playsInline
          src={src}
        />
      )}
    </Modal>
  )
}
